import React, { type ReactNode } from 'react';
import { type IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  actions?: ReactNode,
  children: ReactNode,
  icon?: IconDefinition,
  title: string
}

export default function Section({ actions, children, icon, title }: Props) {
  return (

    <div className="d-flex flex-column gap-2">
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
        <div className="d-flex gap-2 fs-large fw-semibold align-items-center">
          {icon && <FontAwesomeIcon className="text-primary" icon={icon} />}
          {title}
        </div>
        {actions}
      </div>
      {children}
    </div>
  );
}
